<template>
  <div v-if="singleRecipe != null">
    <Presentation class="mb-4"></Presentation>
    <DiscoverRecipes class="mb-4"></DiscoverRecipes>
    <Ingredients class="mb-4"></Ingredients>
    <Pairing class="mb-4"></Pairing>
    <RelatedRecipes class="mb-4"></RelatedRecipes>
  </div>
  <app-sidebar-button></app-sidebar-button>
</template>

<script>
import Presentation from "../components/single-recipe/Presentation.vue";
import DiscoverRecipes from "../components/single-recipe/DiscoverRecipes.vue";
import Ingredients from "../components/single-recipe/Ingredients.vue";
import Pairing from "../components/single-recipe/Pairing.vue";
import RelatedRecipes from "../components/single-recipe/RelatedRecipes.vue";
import AppSidebarButton from "../components/AppSidebarButton.vue";
export default {
  data() {
    return {
      singleRecipe: null,
    };
  },
  computed: {
    access_token: function() {
      return this.$store.getters["userdata/getAccessToken"];
    },
    languages: function() {
      return this.$store.getters["labels/languages"];
    },
  },
  async mounted() {
    this.singleRecipe = await this.$store.dispatch("recipes/getSingleRecipe", {
      access_token: this.access_token,
      id: this.$route.params.id,
    });
    this.importRecipesTranslations();
    this.importIngredientsTranslations();
  },
  methods: {
    async importRecipesTranslations() {
      let translations = new Array(this.languages.length);
      this.languages.forEach((elem, index) => {
        translations[index] = {};
        translations[index].locale = elem.code;
        translations[index].labels = {};
      });
      var path = this.singleRecipe.key;
      this.singleRecipe.labels.data.forEach((label) => {
        let index = translations.findIndex(
          (x) => x.locale === label.attributes.locale
        );
        var value = label.attributes.title;
        var obj = translations[index].labels;
        var parts = path.split("."),
          part;
        var last = parts.pop();
        // eslint-disable-next-line no-cond-assign
        while ((part = parts.shift())) {
          if (typeof obj[part] != "object") obj[part] = {};
          obj = obj[part]; // update "pointer"
        }
        obj[last] = value;
      });
      translations.forEach((elem) => {
        let old = this.$i18n.getLocaleMessage(elem.locale);
        this.$i18n.setLocaleMessage(elem.locale, {
          ...old,
          ...elem.labels,
        });
      });
    },
    async importIngredientsTranslations() {
      let translations = new Array(this.languages.length);
      this.languages.forEach((elem, index) => {
        translations[index] = {};
        translations[index].locale = elem.code;
        translations[index].labels = {};
      });
      this.singleRecipe.ingredients.forEach((elem) => {
        var path = elem.ingredient.data.attributes.key;
        elem.ingredient.data.attributes.labels.data.forEach((label) => {
          let index = translations.findIndex(
            (x) => x.locale === label.attributes.locale
          );
          var value = label.attributes.value;
          var obj = translations[index].labels;
          var parts = path.split("."),
            part;
          var last = parts.pop();
          // eslint-disable-next-line no-cond-assign
          while ((part = parts.shift())) {
            if (typeof obj[part] != "object") obj[part] = {};
            obj = obj[part]; // update "pointer"
          }
          obj[last] = value;
        });
      });
      translations.forEach((elem) => {
        let old = this.$i18n.getLocaleMessage(elem.locale);
        this.$i18n.setLocaleMessage(elem.locale, {
          ...old,
          ...elem.labels,
        });
      });
      this.labelLoaded = true;
    },
  },
  components: {
    Presentation,
    DiscoverRecipes,
    Ingredients,
    Pairing,
    AppSidebarButton,
    RelatedRecipes,
  },
};
</script>

<style></style>
